import { useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { useForm } from '@kanda-libs/ks-component-ts';
import { StringIndexedObject, useToast } from '@kanda-libs/ks-design-library';
import {
  type CompanyDirectorReport,
  type UserType,
  services,
  useSubmit,
} from '@kanda-libs/ks-frontend-services';

import { serviceConvert } from 'utils';

import { REPORT } from './constants';

export interface CompanyReportButtonFormValues {
  report: keyof typeof REPORT;
}

export interface CompanyReportModalHook {
  form: UseFormReturn<CompanyReportButtonFormValues>;
  report?: Partial<CompanyDirectorReport>;
  submitted: boolean;
  setSubmitted: (submitted: boolean) => void;
  isSubmitting: boolean;
  onSubmit: (formValues: StringIndexedObject) => void;
  copied: boolean;
  setCopied: (copied: boolean) => void;
}

export default function useCompanyReportModal(
  user: UserType,
): CompanyReportModalHook {
  const form = useForm<CompanyReportButtonFormValues>();
  const { showError } = useToast();
  const [submitted, setSubmitted] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { submit } = useSubmit(
    serviceConvert(services.infoDirector.infoDirector),
  );

  const [report, setReport] = useState<Partial<CompanyDirectorReport>>({});

  const onSubmit = (formValues: StringIndexedObject) => {
    setIsSubmitting(true);

    submit({ body: user, params: { report: formValues.report } }).then(
      ({ error, data }) => {
        if (error) {
          showError('There was an error running this report');
          setIsSubmitting(false);
          return;
        }

        setReport(data as Partial<CompanyDirectorReport>);
        setIsSubmitting(false);
        setSubmitted(true);
      },
    );
  };

  return {
    form,
    report,
    submitted,
    setSubmitted,
    isSubmitting,
    onSubmit,
    copied,
    setCopied,
  };
}
